import { render } from "./lockscreen.vue?vue&type=template&id=40bc5e8a&scoped=true"
import script from "./lockscreen.vue?vue&type=script&lang=js"
export * from "./lockscreen.vue?vue&type=script&lang=js"

import "./lockscreen.vue?vue&type=style&index=0&id=40bc5e8a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bc5e8a"]])

export default __exports__